module.exports = __webpack_public_path__ + "assets/a82cb6a216e70ed0f9b92cfb68a455a4.png";